const mockDates = ['07/19/2019', '11/03/2019', '03/04/2013'];
export default mockDates;
